/**
 *
 *  Stripe Elements
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 03/04/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import { StripeContext } from "../StripeProvider/StripeProvider";

const fonts = {
  fonts: [
    {
      cssSrc:
        "https://fonts.googleapis.com/css2?family=Poppins:wght@400&display=swap",
    },
  ],
};

export const StripeElementsContext = React.createContext(null);

export class StripeElements extends React.Component {
  static propTypes = {};

  static contextType = StripeContext;

  static defaultProps = {
    children: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      registeredElements: [],
    };
  }

  render() {
    return (
      <StripeElementsContext.Provider
        value={{
          addElementsLoadListener: (cb) => {
            // Return the existing elements instance if we already have one.
            if (this._elements) {
              cb(this._elements);

              return;
            }

            const { children, ...options } = this.props;

            this.context.addStripeLoadListener((stripe) => {
              this.setState({ stripe });

              if (this._elements) {
                cb(this._elements);
              } else {
                this._elements = stripe.elements({ ...options, ...fonts });
                cb(this._elements);
              }
            });
          },
          registerElement: (
            element,
            impliedTokenType,
            impliedSourceType,
            impliedPaymentMethodType
          ) => {
            this.setState((prevState) => ({
              registeredElements: [
                ...prevState.registeredElements,
                {
                  element,
                  ...(impliedTokenType ? { impliedTokenType } : {}),
                  ...(impliedSourceType ? { impliedSourceType } : {}),
                  ...(impliedPaymentMethodType
                    ? { impliedPaymentMethodType }
                    : {}),
                },
              ],
            }));
          },
          unregisterElement: (el) => {
            this.setState((prevState) => ({
              registeredElements: prevState.registeredElements.filter(
                ({ element }) => element !== el
              ),
            }));
          },
          getRegisteredElements: () => this.state.registeredElements,
        }}
      >
        {React.Children.only(this.props.children)}
      </StripeElementsContext.Provider>
    );
  }
}

export const useElementsContext = () => {
  const ctx = React.useContext(StripeElementsContext);

  if (!ctx) {
    throw new Error(
      `Could not find Elements context; You need to wrap the part of your app that in an <Elements> provider.`
    );
  }

  return ctx;
};

export default StripeElements;
